import React, { useEffect, useRef } from 'react';
import { ReactComponent as Logo } from 'asset/img/head/logo.svg';
import jdLoginTools_create_by_team_aris from 'utils/login';
import { loginOptions } from 'utils';
import styles from './index.less';

const Login = () => {
  const loginDivRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    jdLoginTools_create_by_team_aris.initLoginForm(loginDivRef.current, { ...loginOptions });
  }, []);
  return (
    <div className={styles.login}>
      <div className={styles.header}>
        <Logo className={styles.logo} />
      </div>
      <div className={styles.main}>
        <div className={styles.mainCon}>
          <div className={styles.mainConLeft}>
            {/* <p className={`${styles.text} ${styles.textTop}`}>“</p>
            <p className={`${styles.text} ${styles.textLeft}`}>只要生命还可珍贵，</p>
            <p className={`${styles.text} ${styles.textRight}`}>医生这个职业就永远倍受崇拜”</p>
            <p className={`${styles.text} ${styles.textRight}`}>-------爱默生</p> */}
          </div>
          <div className={styles.mainConRight} ref={loginDivRef} />
        </div>
      </div>
      <div className={styles.footer}>
        <div className={styles.copyRightInfo}>
          <p>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002000088" target="_blank" rel="noreferrer">
              京公网安备 11000002000088号
            </a>
            <span className={styles.copyRightSplit}>|</span>
            <span>京ICP证070359号</span>
            <span className={styles.copyRightSplit}>|</span>
            <a href="//img30.360buyimg.com/poprx/jfs/t1/45702/1/7206/3652062/5d4d3f4fE7ea82da4/207332da28ae8230.png" target="_blank" rel="noreferrer">
              互联网药品信息服务资格证编号(京)-经营性-2014-0008
            </a>
            <span className={styles.copyRightSplit}>|</span>
            <span>新出发京零&nbsp;字第大120007号</span>
          </p>
          <p>
            <span>互联网出版许可证编号新出网证(京)字150号</span>
            <span className={styles.copyRightSplit}>|</span>
            <a href="//pro.jd.com/mall/active/3bVDLXHdwVmdQksGF8TtS7ocq1NY/index.html" target="_blank" rel="noreferrer">
              出版物经营许可证
            </a>
            <span className={styles.copyRightSplit}>|</span>
            <a href="//misc.360buyimg.com/wz/wlwhjyxkz.jpg" target="_blank" rel="noreferrer">
              网络文化经营许可证京网文[2014]2148-348号
            </a>
            <span className={styles.copyRightSplit}>|</span>
            <span>违法和不良信息举报电话：4006561155</span>
          </p>
          <p>
            <span className={styles.copyRightText}>
              Copyright&nbsp;©&nbsp;2004&nbsp;-&nbsp;
              <em>2021</em>&nbsp;&nbsp;京东JD.com&nbsp;版权所有
            </span>
            <span className={styles.copyRightSplit}>|</span>
            <span>消费者维权热线：4006067733</span>
            <a className={styles.copyRightLicense} href="//pro.jd.com/mall/active/38PitHBfR7ZopNHRSHnuuWR5AMDL/index.html" target="_blank" rel="noreferrer">
              经营证照
            </a>
            <span className={styles.copyRightSplit}>|</span>
            <span>(京)网械平台备字(2018)第00003号</span>
            <span className={styles.copyRightSplit}>|</span>
            <a className={styles.mod_business_license} href="//storage.jd.com/imgtools/cbdaa22553-dccaf290-d1af-11e8-a840-89f99f5f0056.jpeg" target="_blank" rel="noreferrer">
              营业执照
            </a>
          </p>
          <p className={styles.mod_copyright_inter}>
            <a className={styles.mod_copyright_inter_lk} href="//www.joybuy.com/?source=1&visitor_from=3" target="_blank" rel="noreferrer">
              <i className={`${styles.mod_copyright_inter_ico} ${styles.mod_copyright_inter_ico_global}`} />
              Global Site
            </a>
            <span className={styles.copyRightSplit}>|</span>
            <a className={styles.mod_copyright_inter_lk} href="//www.jd.ru/?source=1&visitor_from=3" target="_blank" rel="noreferrer">
              <i className={`${styles.mod_copyright_inter_ico} ${styles.mod_copyright_inter_ico_rissia}`} />
              Сайт России
            </a>
            <span className={styles.copyRightSplit}>|</span>
            <a className={styles.mod_copyright_inter_lk} href="//www.jd.id/?source=1&visitor_from=3" target="_blank" rel="noreferrer">
              <i className={`${styles.mod_copyright_inter_ico} ${styles.mod_copyright_inter_ico_indonesia}`} />
              Situs Indonesia
            </a>
            <span className={styles.copyRightSplit}>|</span>
            <a className={styles.mod_copyright_inter_lk} href="//www.joybuy.es/?source=1&visitor_from=3" target="_blank" rel="noreferrer">
              <i className={`${styles.mod_copyright_inter_ico} ${styles.mod_copyright_inter_ico_spain}`} />
              Sitio de España
            </a>
            <span className={styles.copyRightSplit}>|</span>
            <a className={styles.mod_copyright_inter_lk} href="//www.jd.co.th/?source=1&visitor_from=3" target="_blank" rel="noreferrer">
              <i className={`${styles.mod_copyright_inter_ico} ${styles.mod_copyright_inter_ico_thailand}`} />
              เว็บไซต์ประเทศไทย
            </a>
          </p>
          <p>
            <span>京东旗下网站：</span>
            <a href="https://www.jdpay.com/" target="_blank" rel="noreferrer">
              京东钱包
            </a>
            <span className={styles.copyRightSplit}>|</span>
            <a href="https://www.jdcloud.com" target="_blank" rel="noreferrer">
              京东智联云
            </a>
          </p>
        </div>
        <p className={styles.copyRightAuth}>
          <a className={`${styles.copyright_auth_ico} ${styles.copyright_auth_ico_2}`} href="https://ss.knet.cn/verifyseal.dll?sn=2008070300100000031&ct=df&pa=700817" target="_blank" rel="noreferrer">
            可信网站信用评估
          </a>
          <a className={`${styles.copyright_auth_ico} ${styles.copyright_auth_ico_3}`} href="http://www.cyberpolice.cn/" target="_blank" rel="noreferrer">
            网络警察提醒你
          </a>
          <a className={`${styles.copyright_auth_ico} ${styles.copyright_auth_ico_4}`} href="https://search.szfw.org/cert/l/CX20120111001803001836" target="_blank" rel="noreferrer">
            诚信网站
          </a>
          <a className={`${styles.copyright_auth_ico} ${styles.copyright_auth_ico_5}`} href="http://www.12377.cn" target="_blank" rel="noreferrer">
            中国互联网举报中心
          </a>
          <a className={`${styles.copyright_auth_ico} ${styles.copyright_auth_ico_6}`} href="http://www.12377.cn/node_548446.htm" target="_blank" rel="noreferrer">
            网络举报APP下载
          </a>
        </p>
      </div>
    </div>
  );
};

export default Login;
